import { IUserRoles } from '../../Interfaces/IUserRoles';
import { UserRolesActionType, SetUserRolesAction, ClearUserRolesAction } from './action-types';

export const setUserRoles = (roles: IUserRoles): SetUserRolesAction => ({
  type: UserRolesActionType.SET_USER_ROLES,
  payload: roles,
});

export const clearUserRoles = (): ClearUserRolesAction => ({
  type: UserRolesActionType.CLEAR_USER_ROLES,
});